<template>
  <v-container class="pt-0 pb-5">
    <v-row>
      <v-col>
        <div class="pa-2 rounded elevation-1 bg-white">
          <SportipsButton backButton chevronLeft>Retour</SportipsButton>
          <div class="text-h6 font-weight-bold mt-3 mb-2">Exporter les équipes</div>
          <div class="text-body-2 text-medium-emphasis mb-4">
            Groupes déclarés via un lien de groupe et export PDF par groupe.
          </div>

          <v-progress-linear v-if="loading" indeterminate color="primary-dark" class="mb-4" />

          <v-alert v-if="loadError" type="error" variant="tonal" class="mb-4" density="compact">
            Impossible de charger la liste des groupes.
          </v-alert>

          <template v-else-if="!loading">
            <v-text-field v-model="search" label="Rechercher un groupe" prepend-inner-icon="mdi-magnify" clearable
              density="compact" variant="outlined" class="mb-4" hide-details />

            <div v-if="equipes.length === 0" class="text-body-1 text-medium-emphasis">
              Aucun lien de groupe sur ce module pour l'instant.
            </div>

            <div v-else-if="filteredEquipes.length === 0" class="text-body-1 text-medium-emphasis">
              Aucun groupe ne correspond à votre recherche.
            </div>

            <v-table v-else density="compact">
              <thead>
                <tr>
                  <th class="text-left">Nom du groupe</th>
                  <th class="text-right">Inscrits</th>
                  <th class="text-right">Export</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="equipe in filteredEquipes" :key="equipe.id">
                  <td class="font-weight-medium">{{ equipe.nom }}</td>
                  <td class="text-right">{{ equipe.nb_inscrits }}</td>
                  <td class="text-right">
                    <v-btn color="primary-dark" density="compact" prepend-icon="mdi-file-pdf-box"
                      :loading="exportLoadingId === equipe.id" @click="exportPdf(equipe)">
                      Télécharger
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </template>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";

export default {
  data() {
    return {
      equipes: [],
      loading: false,
      loadError: false,
      search: "",
      exportLoadingId: null,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    filteredEquipes() {
      const q = (this.search ?? "").trim().toLowerCase();
      let list = this.equipes;
      if (q) {
        list = list.filter((e) => (e.nom ?? "").toLowerCase().includes(q));
      }
      return [...list].sort((a, b) =>
        (a.nom ?? "").localeCompare(b.nom ?? "", "fr", { sensitivity: "base" })
      );
    },
  },
  created() {
    this.fetchEquipes();
  },
  methods: {
    async fetchEquipes() {
      this.loading = true;
      this.loadError = false;
      const data = await AdminService.getNfl26Equipes(this.mainStore.module.id);
      this.loading = false;
      if (!data || !Array.isArray(data.equipes)) {
        this.loadError = !data;
        this.equipes = [];
        return;
      }
      this.equipes = data.equipes;
    },
    slugFilename(nom) {
      const slug = (nom ?? "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9_-]+/g, "_")
        .replace(/^_+|_+$/g, "");
      return slug || "equipe";
    },
    async exportPdf(equipe) {
      this.exportLoadingId = equipe.id;
      const blob = await AdminService.exportNfl26EquipePdf({
        id_module: this.mainStore.module.id,
        id_groupe: equipe.id,
      });
      this.exportLoadingId = null;
      if (!blob) {
        this.mainStore.notification.send("Impossible de générer le PDF.", "error");
        return;
      }
      const url = window.URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      const date = new Date().toISOString().split("T")[0];
      link.setAttribute("download", `Groupe_${this.slugFilename(equipe.nom)}_${date}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
  },
};
</script>
